import {createStore, applyMiddleware} from 'redux'
import createSagaMiddleware from 'redux-saga'
import {composeWithDevTools} from 'redux-devtools-extension'
import {persistStore} from 'redux-persist'

import {rootSaga} from './modules/index.saga'
import {rootReducer} from './modules/index.reducer'

const sagaMiddleware = createSagaMiddleware()

export const store = createStore(rootReducer(), composeWithDevTools(applyMiddleware(sagaMiddleware)))

sagaMiddleware.run(rootSaga)

export const persistor = persistStore(store)
